export const btlObjectiveSchema = {
	schema: {
		title: 'btl objective schema',
		description: 'BTL Objective Schema',
		version: 0,
		primaryKey: 'sfid',
		type: 'object',
		properties: {
			id: {
				type: 'number',
			},
			sfid: {
				type: 'string',
				maxLength: 250,
			},
			meetingmodule_c: {
				type: 'string',
			},
			btl_objective_c: {
				type: 'string',
			},
		},
		required: ['id', 'sfid', 'meetingmodule_c', 'btl_objective_c'],
	},
};
